import { useEffect } from "react";
import logger from "../Components/Logger";

export default function GoogleReviews() {

  // Ce composant charge le script de Google Reviews d'Elfsight et rend le widget de Google Reviews
  // source ; https://dash.elfsight.com/apps/google-reviews

  useEffect(() => {
    // Empêche de charger le script plusieurs fois
    const existingScript = document.querySelector(
      'script[src="https://elfsightcdn.com/platform.js"]'
    );

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = "https://elfsightcdn.com/platform.js";
      script.async = true;
      document.body.appendChild(script);
      logger.info("Google Reviews script loaded successfully.");
    }
  }, []);

  return (
    <div
      className="elfsight-app-f77b033b-852c-4ff5-9687-a94ac5afeba1"
      data-elfsight-app-lazy
    ></div>
  );
}